import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { ErrorBoundary, styleVariables } from '@cmd/ui-components';
import { Button } from '@interstate/components/Button';
import { ChevronLeftIcon } from '@interstate/components/Icons';
import { Slideout } from '@interstate/components/SlideOut';
import { useDispatch, useSelector } from 'react-redux';
import LeadsByAge from '../../tiles/tiles/leads-by-age/LeadsByAge';
import ProductsThatDroveLeads from '../../tiles/tiles/products-that-drove-leads/ProductsThatDroveLeads';
import SoldInventoryAge from '../../tiles/tiles/sold-inventory-age/SoldInventoryAge';
import TopInStockVehiclesByLeads from '../../tiles/tiles/top-in-stock-vehicles-by-leads/TopInStockVehiclesByLeads';
import TopLeadSources from '../../tiles/tiles/top-lead-sources/TopLeadSources';
import TopModelsByLeads from '../../tiles/tiles/top-models-by-leads/TopModelsByLeads';
import TopTradeInVehiclesByLeads from '../../tiles/tiles/top-trade-in-vehicles-by-leads/TopTradeInVehiclesByLeads';
import TopVehiclesByLeads from '../../tiles/tiles/top-vehicles-by-leads/TopVehiclesByLeads';
import TotalGrossProfit from '../../tiles/tiles/total-gross-profit/TotalGrossProfit';
import { LeadsDataSource } from '../../utils/apis/leadsApiUtils';
import { sidePanelViewSelector, updateSidePanelView } from './SlideOutUtilities';
import './SlideOut.scss';
const SlideOutTiles = ({ sidePanelView, }) => {
    const tiles = {
        atKbbTotalLeads: [
            _jsx(TopVehiclesByLeads, { source: LeadsDataSource.ATKBB }),
            _jsx(TopLeadSources, { source: LeadsDataSource.ATKBB }),
            _jsx(ProductsThatDroveLeads, { source: LeadsDataSource.ATKBB }),
        ],
        ddcTotalLeads: [
            _jsx(TopLeadSources, { source: LeadsDataSource.DDC }),
            _jsx(TopModelsByLeads, { source: LeadsDataSource.DDC }),
        ],
        vinTotalLeads: [
            _jsx(TopLeadSources, { source: LeadsDataSource.VIN_SOLUTIONS }),
            _jsx(TopInStockVehiclesByLeads, { source: LeadsDataSource.VIN_SOLUTIONS }),
        ],
        unitsSold: [
            _jsx(TotalGrossProfit, {}),
            _jsx(SoldInventoryAge, {}),
        ],
        icoTotalLeads: [
            _jsx(LeadsByAge, { source: LeadsDataSource.ICO }),
            _jsx(TopTradeInVehiclesByLeads, {}),
        ],
    };
    // Add a key to each tile for the ErrorBoundary
    const tilesForView = (tiles[sidePanelView || ''] || []).map((TileComponent, index) => ({
        component: TileComponent,
        key: `tile-${sidePanelView}-${index}`,
    }));
    return (_jsx(_Fragment, { children: tilesForView.map(({ component, key }) => (_jsx(ErrorBoundary, { children: component }, key))) }));
};
const SlideOut = () => {
    const dispatch = useDispatch();
    const sidePanelView = useSelector(sidePanelViewSelector);
    const slideoutTopOffset = styleVariables.slideouttopoffset;
    const closeSidePanel = () => dispatch(updateSidePanelView(null));
    return (_jsx(Slideout, { className: "cmd-slide-out", onHide: closeSidePanel, position: "right", topOffset: slideoutTopOffset, panelWidth: "393px", show: !!sidePanelView, disableEnforceFocus: true, header: (_jsx(Button, { buttonStyle: "tertiary", className: "cmd-slideout-close", onClick: closeSidePanel, size: "large", startIcon: _jsx(ChevronLeftIcon, {}), children: "BACK" })), children: _jsx("div", { className: "Slideout-Widget-Container", children: _jsx(ErrorBoundary, { children: _jsx(SlideOutTiles, { sidePanelView: sidePanelView }) }) }) }));
};
export default SlideOut;
